import SubcategoryPage from '@/components/template/SubcategoryPage';

const TrickyStool = () => {
  const products = [
    {
      title: "Tricky Stool Classic",
      imageSrc: "https://images.unsplash.com/photo-1579656381253-c2e57a7d7c81?auto=format&fit=crop&q=80",
      url: "/proizvodi/tricky-stool-classic"
    },
    {
      title: "Tricky Stool Modern",
      imageSrc: "https://images.unsplash.com/photo-1562663474-6cbb3eaa4d14?auto=format&fit=crop&q=80",
      url: "/proizvodi/tricky-stool-modern"
    },
    {
      title: "Tricky Stool Premium",
      imageSrc: "https://images.unsplash.com/photo-1581539250439-c96689b516dd?auto=format&fit=crop&q=80",
      url: "/proizvodi/tricky-stool-premium"
    }
  ];

  return (
    <SubcategoryPage
      title="Tricky Stool"
      description="Inovativni in zabavni Tricky stolčki, ki združujejo udobje in igrivost za sodoben dom."
      heroImage="https://images.unsplash.com/photo-1579656381253-c2e57a7d7c81?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default TrickyStool;